module.exports = __webpack_public_path__ + "static/media/How to saveupdate visa related information into the system.4f500e42.png";